import router from './index';
import store from '@/store/index';
import { getToken, getRefreshToken } from '@/utils/auth';
import IM from '@/plugins/im';
import adjust from '@/utils/adjust';
import MyLog from '@/utils/my-log';

router.beforeEach(async (to, from, next) => {
  if (to.query) {
    const { s } = to.query;
    if (s) {
      localStorage.setItem('comm_params_source', s);
      localStorage.setItem(
        'comm_params_source_time',
        new Date().getTime().toString()
      );
    }
  }
  if (from.meta && from.meta.keepAlive) {
    const $main = document.querySelector('main');
    const scrollTop = $main ? $main.scrollTop : 0;
    from.meta.scrollTop = scrollTop;
  }
  // determine whether the user has logged in
  const hasToken = getToken() || store.getters.token;
  const refreshToken = getRefreshToken();
  if (hasToken || refreshToken) {
    const userInfo = store.getters.userInfo;
    if (userInfo) {
      const { userKind } = userInfo;
      if (to.meta.needPlayer && userKind !== 'Player') {
        next('/');
      } else {
        next();
      }
    } else {
      try {
        const { userKind } = await store.dispatch('app/getUserInfo', {
          token: hasToken,
          refreshToken,
          isCreate: true
        });
        // test
        // store.dispatch('app/setSomeUserInfo', { userLevel: 11 })
        // if ((!window.location.port || location.href.includes('chat'))  || location.href.includes('/voice-room')) {
        //   IM.imSdkInit()
        // }
        IM.imSdkInit();

        if (to.meta.needPlayer && userKind !== 'Player') {
          next('/');
        } else {
          next({ ...to, replace: true });
        }
      } catch (error) {
        MyLog.captureException('white-screen', {
          tags: {
            guard: 'beforeEach'
          },
          context: error
        });
        next();
      }
    }
  } else {
    /* has no token*/
    if (
      to.meta.needLogin &&
      !to.query.isApp &&
      location.href.indexOf('line-recharge') === -1
    ) {
      // in the free login whitelist, go directly
      if (window.sessionStorage.getItem('beforeJump2LoginLine')) return;
      next(`/login?redirect=${encodeURIComponent(to.fullPath)}`);
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next();
    }
  }
});

router.afterEach((to, from) => {
  if (to.meta && to.meta.scrollTop) {
    const $main = document.querySelector('main');
    if ($main) {
      $main.scrollTop = to.meta.scrollTop;
    }
  }
  let prePageInfo = window.prePageInfo;
  if (window.name) {
    const storageKey = `PRE_PAGE_${window.name}`;
    const prePageInfoStr = sessionStorage.getItem(storageKey);
    prePageInfo = prePageInfoStr ? JSON.parse(prePageInfoStr) : {};
    sessionStorage.removeItem(storageKey);
    window.prePageInfo = prePageInfo || prePageInfo;
  }
  if (window.prePageInfo && to.fullPath === window.prePageInfo.firstPage) {
    router.prePageInfo = window.prePageInfo;
  } else {
    router.prePageInfo = {
      prePage: from.fullPath,
      preRouterName: from.name,
      firstPage: to.fullPath
    };
    window.prePageInfo = '';
  }
  adjust('page_show', {
    current_page: to.name,
    current_path: to.fullPath
  });
});
